import request from '@/utils/request'


// 查询短视频话题列表
export function listCommunityTopic(query) {
  return request({
    url: '/community/admin/community/topic/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询短视频话题分页
export function pageCommunityTopic(query) {
  return request({
    url: '/community/admin/community/topic/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询短视频话题详细
export function getCommunityTopic(data) {
  return request({
    url: '/community/admin/community/topic/detail',
    method: 'get',
    params: data
  })
}

// 新增短视频话题
export function addCommunityTopic(data) {
  return request({
    url: '/community/admin/community/topic/add',
    method: 'post',
    data: data
  })
}

// 修改短视频话题
export function updateCommunityTopic(data) {
  return request({
    url: '/community/admin/community/topic/edit',
    method: 'post',
    data: data
  })
}

// 删除短视频话题
export function delCommunityTopic(data) {
  return request({
    url: '/community/admin/community/topic/delete',
    method: 'post',
    data: data
  })
}
